import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import UserContext from '../context/UserContext'

import Navbar from '../components/Navbar'
import NavbarWhitelisted from '../components/NavbarWhitelisted'

import { API, graphqlOperation } from 'aws-amplify'
import { listFccReports } from "../graphql/queries"

import { awsDateMdy } from "../util/typeUtil"
import { sortByDate } from "../util/modelUtil"


const Reports = () => {
  const { isWhitelisted } = useContext(UserContext)
  const [reportList, setReportList] = useState([])
  const [successMsg, setSuccessMsg] = useState(null)
  const [errorMsg, setErrorMsg] = useState(null)
  const pageLimit = 50


  const fetchReports = async () => {   
    try {
      // NOTE: Using high query limit to retrieve a lot of reports to maintain order.
      // - Sort not working with graphql queryReportsByListReportsSortByCreatedAt
      // - Sort hack not working:
      //      let filterDate = new Date()
      //      filterDate.setDate(filterDate.getDate() - 50)
      //      filter: {publishedAt: {gt: filterDate}}
      const res = await API.graphql(graphqlOperation(listFccReports, {
        filter: {
          publishedAt: {gt: '0000-00-00T00:00:00Z'}, // filter out unpublished reports
        }, 
        limit: 10000,
      }))

      let items = res.data.listFccReports.items
      items = items.filter((record) => record._deleted !== true)
      items = items.filter((record) => record.publishedAt !== null)
      items = sortByDate(items, 'publishedAt')
      items = items.slice(0, pageLimit)
      setReportList(items)

    } catch (error) {
      console.error('Error fetching reports:', error);
    }
  }

  useEffect(() => {
    fetchReports()
  }, [])

  return (
    <>
      { isWhitelisted ? <NavbarWhitelisted /> : <Navbar />}
      <div className="container-fluid banner text-center text-white">
        Reports
      </div>

      <div className="page-container">
        { successMsg &&
        <div className="alert alert-success text-center" role="alert">
          {successMsg}
        </div>
        }
        { errorMsg &&
        <div className="alert alert-danger text-center" role="alert">
          {errorMsg}
        </div>
        }

        <div className="row">
          <div className="col-md-7">
            <strong>Title</strong>
          </div>
          <div className="col-md-3 text-center">
            <strong>Date</strong>
          </div>
          {/* <div className="col-md-2 text-center">
            <strong>Document</strong>
          </div> */}
        </div>
      

        {reportList.map((item, index) => (
        <div className="model-list" key={index}>
          <div className="row">
            <div className="col-md-7">
              <Link to={`/home/daily/${item.id}`}>{item.title}</Link>
            </div>
            <div className="col-md-3 text-center">
              {awsDateMdy(item.publishedAt)}
            </div>
            {/* <div className="col-md-2 text-center">
              <a href={item.pdfUrl} style={{color: 'black'}}>
                <i className="fa-solid fa-file-pdf fa-xl"
                  style={{ cursor: 'pointer', color: rowHoverIndex === index ? '#2e6dff' : 'black' }}
                  onMouseEnter={() => setRowHoverIndex(index)}
                  onMouseLeave={() => setRowHoverIndex(null)}></i>
              </a>
            </div> */}
          </div>
        </div>
        ))}
      
      </div>
    </>
  )
}

export default Reports